import React from 'react'
import { NumberInput, type NumberInputProps } from '@mantine/core'

export type AppNumberInputProps = NumberInputProps

/** Standard numeric input with consistent sizing. */
export default function AppNumberInput ({ size = 'sm', ...props }: AppNumberInputProps) {
  return <NumberInput radius="sm" size={size} {...props} />
}
